module.exports = __webpack_public_path__ + "src/assets/img/Party.43df8d38.svg";